import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
} from "../../../shared/routes/auth.routes";
import { Client } from "../../api-client";
import { TABLE_ROWS_COUNT } from "../../../shared/constants";
import { API_CREATE_BILLING_CYCLE, API_GET_BILLING_CYCLE_LIST, API_UPDATE_BILLING_CYCLE,API_DELETE_BILLING_CYCLE, API_GET_BILLING_CYCLE_SUMMARY } from "../../../shared/routes/private.routes";

const config = {
  name: "billingCycle",
};
export const getBillingCycleList: any = createAsyncThunk(
  `${config.name}/getbillingCycleList`,
  async ({params, body}: any) => {
    return Client.post(API_GET_BILLING_CYCLE_LIST, body, {params});
  }
);

export const getBillingCycleSummary: any = createAsyncThunk(
  `${config.name}/getbillingCycleSummary`,
  async ({params, body}: any) => {
    return Client.post(API_GET_BILLING_CYCLE_SUMMARY, body);
  }
);
export const createBillingCycle: any = createAsyncThunk(
  `${config.name}/create-billing-cycle`,
  async (body: any) => {
    return Client.post(API_CREATE_BILLING_CYCLE, body);
  }
);

export const updateBillingCycleById: any = createAsyncThunk(
  `${config.name}/update-billing-cycle`,
  async ({ billingId, body }: { billingId: string, body: any }) => {
    const url = API_UPDATE_BILLING_CYCLE + `${billingId}`;
    return Client.put(url, body);
  }
);
export const deleteBillingCycleById: any = createAsyncThunk(
  `${config.name}/deleteBillingCycle`,
  async (billingId: any) => {
    return Client.delete(API_DELETE_BILLING_CYCLE + billingId );
  }
);

export const billingCycleReducer = createSlice({
  name: config.name,
  initialState: {
    loadingBillingCycleList: false as any,
    billingCycleList: [] as any, 
    filters: {} as any, 
    pagination: {page: 0, limit: TABLE_ROWS_COUNT, total: 0}
  },
  reducers: {
    resetBillingCycle: (state) => {
      state.loadingBillingCycleList = false;
      state.billingCycleList = [];
      state.filters = {};
      state.pagination = {page: 0, limit: TABLE_ROWS_COUNT, total: 0};
    },
  },
  extraReducers(builder) {
    builder
    .addCase(getBillingCycleList.pending, (state) => {
      state.loadingBillingCycleList = true;
      state.billingCycleList = [] as any;
    })
    .addCase(getBillingCycleList.fulfilled, (state, action) => {
      state.loadingBillingCycleList = false;
      state.billingCycleList = action?.payload?.data?.data as any;
      state.pagination = {page: action?.payload?.data?.page, limit: action?.payload?.data?.limit, total: action?.payload?.data?.total}
    })
    .addCase(getBillingCycleList.rejected, (state) => {
      state.loadingBillingCycleList = false;
      state.billingCycleList = [] as any;
    })
  },
});

export const { resetBillingCycle } = billingCycleReducer.actions;
export default billingCycleReducer.reducer;

